export default __webpack_public_path__ + "static/media/DS18.c9450cf0.JPG";